// Copied from Graph.ts

export const EXISTING_SUPPLIER_VARIABLE = 'Existing Supplier'

export const EXISTING_SUPPLIER_SUBSIDIARY = 'Existing Supplier Subsidiary'

export const EXISTING_AGREEMENT_VARIABLE = 'Existing Agreement'

export type SupplierMinimal = {
  state: 'ACTIVE' | 'ARCHIVED' | 'INACTIVE' | 'PENDING'
  subsidiaries: string[]
  isPreferred?: boolean
}

export type ProductMinimal = { state: 'ACTIVE' | 'INACTIVE' | 'PENDING' }

export enum SupplierConditionVariants {
  STATE = 'STATE',
  PREFERRED = 'PREFERRED',
}

export enum ProductConditionVariants {
  PRODUCT_STATE = 'PRODUCT_STATE',
}

export const SUPPLIER_PREFERRED_VALUES = ['PREFERRED', 'NOT_PREFERRED'] as const

export type SupplierPreferredConditionValue = (typeof SUPPLIER_PREFERRED_VALUES)[number]

export const getSupplierPreferredConditionValue = (isPreferred?: boolean | null): SupplierPreferredConditionValue =>
  isPreferred ? 'PREFERRED' : 'NOT_PREFERRED'
